export default __webpack_public_path__ + "static/media/loading.1613c43c.gif";